import React from 'react'
import classNames from 'classnames'
import './StepProgressCounter.scss'

const CountBox = ({
  complete,
  isSponsoredStep,
  completeColor,
  incompleteColor,
}) => {
  return (
    <div
      style={{
        backgroundColor: complete
          ? completeColor
          : isSponsoredStep
          ? '#fff'
          : incompleteColor,
        borderRadius: '1.5px',
        width: '20px',
        height: '3px',
      }}
    />
  )
}

export const StepProgressCounter = ({
  total,
  currentStep,
  isSponsoredStep,
  label = 'Step',
  completeColor = '#4C3371',
  incompleteColor = '#C3C3C3',
  showDots = true,
}) => {
  return (
    <div className="step__counter">
      <span
        className={classNames(
          'step__counter__label',
          isSponsoredStep && 'sponsored',
        )}
      >
        {label} {currentStep + 1} of {total}
      </span>
      {showDots && (
        <div className="step__counter__boxes">
          {Array.from({ length: total }).map((_, index) => (
            <CountBox
              completeColor={completeColor}
              incompleteColor={incompleteColor}
              key={index}
              complete={index < currentStep + 1}
            />
          ))}
        </div>
      )}
    </div>
  )
}
